module.exports = __webpack_public_path__ + "img/Icon ionic-ios-leaf-1.ba0de235.svg";